import { Flex, Text, createStyles, rem, Group } from "@mantine/core"
import { Image } from "shared/ui/Image"
import { SocialButton } from "shared/ui/SocialButton"
import { type Instructor } from "shared/types/instructor"
import { API_URL } from "shared/config"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  name: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontWeight: 700,
    fontSize: "1.5rem",

    [theme.fn.smallerThan("md")]: {
      fontSize: "1.25rem",
    },
  },

  position: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontSize: rem(15),

    [theme.fn.smallerThan("md")]: {
      fontSize: theme.fontSizes.sm,
    },
  },
}))

// ----------------------------------------------------------------------

export function InstructorCard({ name, position, avatar, socials }: Instructor): React.JSX.Element {
  const { classes, theme } = useStyles()

  return (
    <Flex direction="column" align="center">
      <Image
        ratio="521/539"
        key={name}
        alt={name}
        src={`${API_URL}/media/${avatar}`}
        sx={{ borderRadius: theme.radius.lg }}
      />
      <Text align="center" mt="xl" px="lg" className={classes.name}>
        {name}
      </Text>
      <Text align="center" fz={15} mt="sm" px="lg" className={classes.position}>
        {position}
      </Text>
      <Group mt="auto" pt="sm" position="center" spacing="md">
        {socials.map((item) => (
          <SocialButton key={item.brand} {...item} />
        ))}
      </Group>
    </Flex>
  )
}
